module.exports = __webpack_public_path__ + "img/audithome_bgimg.4c0feecb.png";